import { useEffect, useState } from 'react';

export const useResize = () => {
  const [resizeTrigger, setResizeTrigger] = useState(0);
  const handleResize = () => {
    setResizeTrigger((prev) => prev + 1);
  };
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return resizeTrigger;
};
